export default "/assets/images/performance-filter-img-02.webp?0e987a056c6c9b84e510462ce08c59e7";